import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import {passworlessUpdate, revokeSession } from "../../../utilities/API/supertokenServices"
import { toast } from "react-toastify"

export const revokeSessionService = createAsyncThunk(
    'fetchPreAuthFAF', revokeSession
)

const initialState = {
    loader: false
}

const revokeSessionSlice = createSlice({
    name: 'preAuth',
    initialState,
    reducers: {
        resetRevokeSession: (state) => {
            state.loader = false
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(revokeSessionService.pending, (state, action) => {
                state.loader = true
            })
            .addCase(revokeSessionService.fulfilled, (state, action) => {
                state.loader = false
            })
            .addCase(revokeSessionService.rejected, (state, action) => {
                toast.error(action.error.message)
                state.loader = false
            })
    }
})

export const { resetRevokeSession } = revokeSessionSlice.actions

export default revokeSessionSlice.reducer

